// extracted by mini-css-extract-plugin
export default {"wrapper":"dz-z","viewport":"ez-z","container":"fz-z","slide":"gz-z"};